import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";
import { STEPS } from "@/data/onboarding";
import { STEP_TRANSITION } from "@/lib/motion";

function stepMarkerClass(done, active) {
  if (done) return "bg-aurora text-[#1a1206]";
  if (active) return "aurora-border text-neutral-900";
  return "border border-neutral-200 text-neutral-400";
}

export function ProgressBar({ currentIdx }) {
  return (
    <div
      data-testid="onboarding-progress"
      className="flex items-center justify-between gap-2 sm:gap-4 max-w-2xl"
    >
      {STEPS.map((s, i) => {
        const done = i < currentIdx;
        const active = i === currentIdx;
        return (
          <div key={s.id} className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
            <span
              data-testid={`onboarding-step-${s.id}-marker`}
              className={`relative flex h-7 w-7 sm:h-8 sm:w-8 flex-none items-center justify-center rounded-full text-[10px] sm:text-xs font-medium transition ${stepMarkerClass(done, active)}`}
            >
              {done ? <Check size={14} strokeWidth={2.5} /> : s.num}
            </span>
            <span
              className={`hidden sm:block text-[11px] uppercase tracking-[0.22em] truncate ${
                active ? "text-neutral-900" : "text-neutral-400"
              }`}
            >
              {s.label}
            </span>
            {i < STEPS.length - 1 && (
              <span
                aria-hidden
                className={`flex-1 h-px ${done ? "bg-gold" : "bg-neutral-100"} transition-colors`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export function StepShell({ stepId, eyebrow, title, children }) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={stepId}
        data-testid={`onboarding-step-${stepId}`}
        {...STEP_TRANSITION}
        className="space-y-8 sm:space-y-10"
      >
        <div className="space-y-3 sm:space-y-4">
          <p className="overline">{eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] max-w-[18ch]">
            {title}
          </h1>
        </div>
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
